<template lang="html">

  <section class="home-alumno">

    <template v-if="brand.banner_home">
      <div class="contenedor-banner container">
        <router-link v-if="brand.banner_home_alumnos.internal" :to="brand.banner_home_alumnos.link">
          <img :src="brand.banner_home_alumnos.src" alt="Banner">
        </router-link>
        <a v-if="brand.banner_home_alumnos.external" :href="brand.banner_home_alumnos.link" target="_blank">
          <img :src="brand.banner_home_alumnos.src" alt="Banner">
        </a>
      </div>
    </template>

    <div class="contenedor-modulos">

      <div class="container row-between ais -superior"
        :hascomunicaciones="(comunicaciones.length > 0) ? 'true' : 'false'" :center="soloCiclosUAX">

        <div class="contenedor-modulo-ofertas column-center" v-if="!soloCiclosUAX">
          <modulo-ofertas></modulo-ofertas>
        </div>

        <div class="contenedor-modulo-comunicaciones" v-if="comunicaciones.length > 0" :full="soloCiclosUAX">
          <modulo-comunicaciones></modulo-comunicaciones>
        </div>

      </div>
    
      <div class="contenedor-encuestas">

        <modulo-encuestas></modulo-encuestas>

      </div>

      <div class="contenedor-modulo-eventos" v-if="brand.hasEventos">
        <modulo-eventos></modulo-eventos>
      </div>


      <div class="contenedor-guias-orientacion" v-if="brand.hasGuiasOrientacion">
        <modulo-guias></modulo-guias>
      </div>

      <div class="contenedor-guias-orientacion info-Alumno" v-if="brand.infoAlumno">
        {{ $t('encabezado.info_alumno') }}
      </div>

      <div class="cover-popup row-center" v-if="mostrarMensajeSS">
        <div class="popup">
          <a @click="hideMensaje" class="close">✕</a>
          <p v-html="$t('encabezado.falta_num_ss')"></p>
          <div class="contenedor-botones row-center">
            <router-link :to="$t('enlaces.cv')" class="btn -solid-primary">{{ $t('header.mi_cv') }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <modulo-orientacion-solicitar v-if="!esHome"></modulo-orientacion-solicitar>
  </section>

</template>

<script lang="js">

import moduloOfertas from './modulo-ofertas';
import moduloComunicaciones from './modulo-comunicaciones';
import moduloEventos from './modulo-eventos';
import moduloGuias from './modulo-guias';
import moduloOrientacionSolicitar from './modulo-orientacion-solicitar';
import moduloEncuestas from '@/components/views/home/modulo-encuestas'

import { mapGetters } from 'vuex'

export default {
  name: 'home-alumno',
  methods: {
    hideMensaje: function () {
      this.mostrarMensajeSS = false;
    },
  },
  data() {
    return {
      mostrarMensajeSS: '',
    }
  },
  components: {
    'modulo-ofertas': moduloOfertas,
    'modulo-comunicaciones': moduloComunicaciones,
    'modulo-encuestas': moduloEncuestas,
    'modulo-eventos': moduloEventos,
    'modulo-guias': moduloGuias,
    'modulo-orientacion-solicitar': moduloOrientacionSolicitar
  },
  computed: {
    ...mapGetters({
      colors: 'basicColors',
      comunicaciones: 'getComunicaciones',
      brand: 'getBrand',
      soloCiclosUAX: 'getsoloCiclosUAX',
      tieneNumSS: 'gettieneNumSegSocial'
    })
  },
  watch: {
    'tieneNumSS'() {
      this.mostrarMensajeSS = !this.tieneNumSS;
    }
  }
}
</script>

<style scoped lang="scss">
.popup {
  min-height: 150px;
  min-width: 50%;

  .contenedor-botones {
    margin-top: 0;

    a {
      margin-top: 10px;
    }
  }
}

.popup p {
  width: 100%;
  text-align: center;
  color: black;
}

.home-alumno {
  min-height: calc(100vh - 309px);
}

.contenedor-banner {
  margin-top: 50px;
  max-width: 1200px;

  img {
    max-width: 100%;
    cursor: pointer;
  }
}

.contenedor-modulos {
  padding: 50px 0;
}

.contenedor-modulos .-superior {
  -webkit-flex-wrap: nowrap;
  -moz-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  -o-flex-wrap: nowrap;
  flex-wrap: nowrap;
  max-width: 1200px;

  &[center="true"] {
    justify-content: center;
  }

  &[hascomunicaciones="false"] {
    justify-content: center;
    -webkit-justify-content: center;
  }
}

.contenedor-modulo-ofertas {
  width: 100%;
  max-width: 768px;
  padding-right: 25px;
}


.contenedor-modulo-eventos {
  width: 100%;
  margin-top: 50px;
  padding: 50px 0;
}

.contenedor-guias-orientacion {
  margin-top: 50px;
}

@media screen and (max-width: 868px) {

  .contenedor-modulos {
    padding-top: 25px;
  }

  .contenedor-modulos .-superior {
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -o-flex-wrap: wrap;
    flex-wrap: wrap;

  }

  .contenedor-modulo-ofertas {
    width: 100%;
    padding-right: 0;
    max-width: 100%;
  }

  .contenedor-modulo-comunicaciones {
    width: 100%;
    margin-top: 50px;
    max-width: 100%;
  }

  .contenedor-banner {
    margin-top: 20px;
  }
}

@media screen and (max-width: 500px) {

  .contenedor-modulo-comunicaciones {
    margin-top: 25px;
  }

  .contenedor-modulo-eventos {
    margin-top: 25px;
    padding-top: 25px;
  }
}

.info-Alumno {
  font-weight: bold;
  padding-left: 20%;
  padding-right: 20%;
  font-size: 15px
}
</style>


// WEBPACK FOOTER //
// src/components/views/home/home-alumno.vue